import { string } from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { usStates } from 'hero-utils/address/states';
const phoneUtil = PhoneNumberUtil.getInstance();
// hardcoded to US as many other things on both BE and FE
// if we ever support other markets, we'll need to update this validation accordingly
const phoneValidator = string()
    .trim()
    .test('libphonenumber', 'Invalid phone number', (val) => {
    if (!!val && !/[a-z]/i.test(val)) {
        try {
            const number = phoneUtil.parse(val, 'US');
            if (phoneUtil.isValidNumberForRegion(number, 'US')) {
                return true;
            }
            // check for territories that are not included in US region -> like Porto Rico, Guam, etc.
            const region = number ? phoneUtil.getRegionCodeForNumber(number) : '';
            if (usStates.some((state) => state.code === region)) {
                return true;
            }
            return false;
        }
        catch (Error) {
            return false;
        }
    }
    return false;
});
export default phoneValidator;
//# sourceMappingURL=index.js.map